export const TextsDomains = {
  AppointmentBooking: 'appointment-booking',
  Default: 'default'
} as const;

export type TextsDomain = (typeof TextsDomains)[keyof typeof TextsDomains];

export type DomainTextsContextProps = { domain: TextsDomain };
